import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const propTypes = {
  /**
   * Background color of the container
   */
  backgroundColor: PropTypes.oneOf(['none', 'brand', 'primary-tan', 'gradient-gray-05-1', 'gradient-gray-05-2', 'gradient-gray-10-1', 'gray-1', 'gray-2', 'gray-3', 'gray-4', 'gray-5', 'gray-05', 'gray-10', 'gray-20', 'gray-50', 'gray-60', 'gray-80', 'black', 'white']),
  /**
   * Adds a border to the container. Use true for all sides or the object definition for custom sides.
   */
  border: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    top: PropTypes.bool,
    right: PropTypes.bool,
    bottom: PropTypes.bool,
    left: PropTypes.bool
  })]),
  /**
   * Adds box-shadow to the container. For custom values, use the className prop.
   */
  boxShadow: PropTypes.bool,
  /**
   * What is displayed inside the container
   **/
  children: PropTypes.any,
  /**
   * Additional classes for the container element
   */
  className: PropTypes.string,
  /**
   * Adds padding to the container. For custom values, use the className prop.
   */
  contentContainer: PropTypes.bool,
  /**
   * Set to true to make the container's max-width 100%
   */
  fullWidth: PropTypes.bool
};
function Container(_ref) {
  let {
    backgroundColor = 'none',
    border = false,
    boxShadow = false,
    children,
    className = '',
    contentContainer = false,
    fullWidth = false
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('asc-container', className, {
      'asc-container--full': fullWidth,
      'asc-container--content': contentContainer,
      'asc-container--border-top': border.top,
      'asc-container--border-right': border.right,
      'asc-container--border-bottom': border.bottom,
      'asc-container--border-left': border.left,
      'asc-container--border': typeof border === 'boolean' && border,
      'asc-container--box-shadow': boxShadow
    }, 'asc-container--' + backgroundColor)
  }, children);
}
Container.propTypes = propTypes;
export default Container;